import { render, staticRenderFns } from "./ANxADxChildhoodPage.vue?vue&type=template&id=34cb84ef"
import script from "./ANxADxChildhoodPage.vue?vue&type=script&lang=js"
export * from "./ANxADxChildhoodPage.vue?vue&type=script&lang=js"
import style0 from "./ANxADxChildhoodPage.vue?vue&type=style&index=0&id=34cb84ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports